import { wealthProApi } from '../../redux/api';
import { useCacheKeyMergeHandler, useCacheKeySerializeQueryArgsHandler, useCacheKeyTransformResponseHandler } from "../../redux/helpers";

const buildEventsQuery = ({ page, limit, sort, searchTerm }) => {
    let baseQuery = `/api/clientdetails/system/events?page=${page}&limit=${limit}`;
    if (sort && sort.length > 0) {
        baseQuery += `&sort=${sort}`;
    }
    if (searchTerm && searchTerm.length > 0) {
        baseQuery += `&searchTerm=${encodeURIComponent(searchTerm)}`;
    }
    return baseQuery;
};

const clientDetailsEventEndpoints = wealthProApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchClientDetailsMicroserviceEvents: builder.query({
            query: (props) => buildEventsQuery(props),
            transformResponse: useCacheKeyTransformResponseHandler,
            serializeQueryArgs: useCacheKeySerializeQueryArgsHandler,
            merge: useCacheKeyMergeHandler,
        }),
    })
});

export const {
    useFetchClientDetailsMicroserviceEventsQuery,
    useLazyFetchClientDetailsMicroserviceEventsQuery,
} = clientDetailsEventEndpoints;